import { render } from "./RoleForm.vue?vue&type=template&id=21c6d586&scoped=true"
import script from "./RoleForm.vue?vue&type=script&lang=js"
export * from "./RoleForm.vue?vue&type=script&lang=js"

import "./RoleForm.vue?vue&type=style&index=0&id=21c6d586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c6d586"]])

export default __exports__